import client from '../axios';
import { GET_BOARD_TASK_TOP5 } from './endpoint';


// 리스트
export const getDashboardTop5NewTaskListAPI = () => {
    return client.get(GET_BOARD_TASK_TOP5);
}